import CommonApi from './../commonApi';
const baseUrl = 'smallScaleMechanizationTool';
const smallScaleMechanizationTool = new CommonApi(baseUrl, 'Средства малой механизации');
export default {
  ...smallScaleMechanizationTool
};
